import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

import { WorkFlowService } from '../../../services/workflow.service';
import { UpdateWorkflowGroupModal } from '../../../modals';
import { NewWorkflowModal } from '../../../modals/new-workflow/new-workflow.component';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
interface Unit {
  organizationUnitId: string;
  organizationId: string;
  unitName: string;
  actionAdditionalDetails: string;
  dateCreated: string;
  dateModified: string;
  createdBy: string;
  modifiedBy: string;
}
@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.scss'],
})
export class WorkflowComponent implements OnInit {
  workflows;
  filter: AppFilter;
  pending: boolean;
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  fields;
  error;
  success;
  units: Array<Unit>;
  selectedUnit: any;
  allAffiliateTypes: any;
  pendingArr: boolean[] | null = [];
  selectedWorkflowTypeId: string = 'COMPANY_NAME_APPROVAL';
  workflowTypes = [
    {
      optionId: 'COMPANY_NAME_APPROVAL',
      optionName: 'COMPANY NAME APPROVAL',
    },
    {
      optionId: 'RC_NUMBER_APPROVAL',
      optionName: 'RC NUMBER APPROVAL',
    },
    {
      optionId: 'TIN_APPROVAL',
      optionName: 'TIN APPROVAL',
    },
    {
      optionId: 'DIRECTOR_STRUCTURE_APPROVAL',
      optionName: ' DIRECTOR STRUCTURE APPROVAL',
    },
    {
      optionId: 'SHAREHOLDER_STRUCTURE_APPROVAL',
      optionName: 'SHAREHOLDER STRUCTURE APPROVAL',
    },
    {
      optionId: 'ADDRESS_APPROVAL',
      optionName: 'ADDRESS APPROVAL',
    },
    {
      optionId: 'OFFICIAL_DOCUMENT_APPROVAL',
      optionName: 'OFFICIAL DOCUMENT APPROVAL',
    },
    {
      optionId: 'EQUIPMENT_APPROVAL',
      optionName: 'EQUIPMENT APPROVAL',
    },
    {
      optionId: 'CONTACT_INFORMATION_APPROVAL',
      optionName: 'CONTACT INFORMATION APPROVAL',
    },
    {
      optionId: 'OTHER_TCC_APPROVAL',
      optionName: 'OTHER TCC APPROVAL',
    },
    {
      optionId: 'OTHER_TIN_APPROVAL',
      optionName: 'OTHER TIN APPROVAL',
    },
  ];
  workflowName = 'COMPANY_NAME_APPROVAL';
  organizationId = localStorage.getItem('organizationId');
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'level',
        op: 'eq',
        data: 0,
      },
      {
        field: 'jpaWorkflowGroupViewPK.workflowType',
        op: 'eq',
        data: this.selectedWorkflowTypeId,
      },
      {
        field: 'workflowGroupDescription',
        op: 'cn',
        data: '',
      },
    ],
  };

  searchUnitFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'organizationId',
        op: 'eq',
        data: this.organizationId,
      },
    ],
  };
  permissions: Array<any> = [];
  orgPending;
  unitFilter: AppFilter;

  selectedCategory;
  constructor(
    private location: Location,
    public modalService: SuiModalService,
    private workflowService: WorkFlowService,
    private companyOwnershipService: CompanyOwnershipService
  ) {
    this.filter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    if (window.localStorage.getItem('permission')) {
      this.permissions = JSON.parse(window.localStorage.getItem('permission'));
    }
    this.unitFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
    this.getAllAffiliateTypes();
  }

  goBack() {
    this.location.back();
  }

  checkPermission(id: string, action: string): boolean {
    if (
      this.permissions.filter((res) => res.permissionId === id)[0] &&
      this.permissions.filter((res) => res.permissionId === id)[0][action] ===
        'true'
    ) {
      return true;
    } else {
      return false;
    }
  }

  selectCategory(data: any) {
    this.selectedCategory = data;
  }

  activateWorkflowModal(workflow) {
    this.modalService
      .open(
        new ConfirmModal(
          'Activate Workflow',
          `Are you sure you want to activate ${workflow.workflowGroupName} workflow?`,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        this.activateWorkflow(workflow);
      })
      .onDeny(() => {});
  }

  activateWorkflow(workflow) {
    this.pending = true;
    this.workflowService
      .activateWorkflow({
        organizationUnitId: this.organizationId,
        workflowGroupId: workflow.jpaWorkflowGroupViewPK.workflowGroupId,
        workflowType: workflow.jpaWorkflowGroupViewPK.workflowType,
      })
      .subscribe((e) => {
        this.getPage(this.currentPage);
      });
  }

  deActivateWorkflowModal(workflow) {
    this.modalService
      .open(
        new ConfirmModal(
          'Deactivate Workflow',
          `Are you sure you want to de-activate ${workflow.workflowGroupName} workflow?`,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        this.deActivateWorkflow(workflow);
      })
      .onDeny(() => {});
  }

  deActivateWorkflow(workflow) {
    this.pending = true;
    this.workflowService
      .deactivateWorkflow({
        organizationUnitId: this.organizationId,
        workflowGroupId: workflow.jpaWorkflowGroupViewPK.workflowGroupId,
        workflowType: workflow.jpaWorkflowGroupViewPK.workflowType,
      })
      .subscribe((e) => {
        this.getPage(this.currentPage);
      });
  }

  newWorkflow() {
    this.modalService
      .open(
        new NewWorkflowModal(
          `New ${this.workflowName} Workflow`,
          this.selectedWorkflowTypeId,
          'ncc',
          false,
          ModalSize.Small
        )
      )
      .onApprove(() => {
        this.getPage(this.currentPage);
      })
      .onDeny(() => {});
  }

  updateWorkflow(item) {
    this.modalService
      .open(
        new UpdateWorkflowGroupModal(
          `Update ${item['workflowGroupDescription']} Workflow`,
          item,
          ModalSize.Small
        )
      )
      .onApprove(() => {
        this.getPage(this.currentPage);
      })
      .onDeny(() => {});
  }

  searchRecords(event) {
    this.searchFilter.rules[2].data = event;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.getPage(this.currentPage);
  }

  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(this.currentPage);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(this.currentPage);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  selectWorkflowType(id, name) {
    this.selectedWorkflowTypeId = id;
    this.workflowName = name;
    this.searchFilter.rules[1].data = id;
    this.getPage(1);
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.workflowService
      .getWorkflows({
        organizationUnitId: 'ncc',
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.rows = this.filter.rows;
          this.workflows = res['rows'];
          this.totalItems = +res['records'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  ngOnInit(): void {
    this.pending = true;
    this.getPage(this.currentPage);
  }

  getOrganizations() {
    // this.unitFilter.filters = JSON.stringify(this.searchUnitFilter);
    this.workflowService
      .getAllOrganizationUnits({
        organizationId: this.organizationId,
        params: this.unitFilter,
      })
      .subscribe(
        (e) => {
          this.units = e.rows as Array<Unit>;
          if (this.units.length > 0) {
            this.selectedUnit = this.units[0];
            this.getPage(this.currentPage);
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  close() {
    this.success = null;
    this.error = null;
  }

  getAllAffiliateTypes() {
    this.pendingArr.push(true);
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res;
        this.setWorkflowTypes(this.allAffiliateTypes);
        console.log(res);
        this.pendingArr.pop();
      },
      (err: any) => {
        this.pendingArr.pop();
        console.log(err);
      }
    );
  }

  setWorkflowTypes(affiliateTypes: any[]) {
    let affiliateTypeWorkflows = affiliateTypes.map((affiliateType) => ({
      optionName: this.getStructureOptionName(affiliateType.optionName),
      optionId: this.getStructureOptionId(affiliateType.optionName),
    }));
    console.log(affiliateTypeWorkflows);
    this.workflowTypes = [
      {
        optionId: 'COMPANY_NAME_APPROVAL',
        optionName: 'COMPANY NAME APPROVAL',
      },
      {
        optionId: 'RC_NUMBER_APPROVAL',
        optionName: 'RC NUMBER APPROVAL',
      },
      {
        optionId: 'TIN_APPROVAL',
        optionName: 'TIN APPROVAL',
      },
      ...affiliateTypeWorkflows,
      {
        optionId: 'ADDRESS_APPROVAL',
        optionName: 'ADDRESS APPROVAL',
      },
      {
        optionId: 'OFFICIAL_DOCUMENT_APPROVAL',
        optionName: 'OFFICIAL DOCUMENT APPROVAL',
      },
      {
        optionId: 'EQUIPMENT_APPROVAL',
        optionName: 'EQUIPMENT APPROVAL',
      },
      {
        optionId: 'CONTACT_INFORMATION_APPROVAL',
        optionName: 'CONTACT INFORMATION APPROVAL',
      },
      {
        optionId: 'OTHER_TCC_APPROVAL',
        optionName: 'OTHER TCC APPROVAL',
      },
      {
        optionId: 'OTHER_TIN_APPROVAL',
        optionName: 'OTHER TIN APPROVAL',
      },
    ];
  }

  getStructureOptionName(optionName: string) {
    return optionName.toUpperCase() + ' STRUCTURE APPROVAL';
  }

  getStructureOptionId(optionName: string) {
    return optionName.toUpperCase() + '_STRUCTURE_APPROVAL';
    // return optionName.toUpperCase().replace(/ /g, "_") + "_STRUCTURE_APPROVAL";
  }
}
